export default window._cmsContent['solar/warranties-and-manuals']